<p>{{ 'Steng {medlem}s tilgang til {gruppe} i {organisasjon}.'|translate: {medlem: medlem().navn, gruppe: gruppe().tittel, organisasjon: gruppe().organisasjonsnavn} }}</p>
<!-- ikke vis før data er lastet for å unngå at tekst hopper -->
@if (assosiasjoner) {
  @if (harAssosiasjoner()) {
    <p>{{ '{medlem} vil bli fjernet som:'|translate: {medlem: medlem().navn} }}</p>
    <ul>
      @if (assosiasjoner().antTilknyttetFremtidigIkkelaastMoeteSomDeltaker > 0) {
        <li class="e2e-erTilknyttetFremtidigIkkelaastMoeteSomDeltaker">
          {{ 'Innkalt til {antall} fremtidige møter'|translate: {antall: assosiasjoner().antTilknyttetFremtidigIkkelaastMoeteSomDeltaker} }}
        </li>
      }
      @if (assosiasjoner().antTilknyttetFremtidigIkkelaastProtokollSomDeltaker) {
        <li class="e2e-erTilknyttetFremtidigIkkelaastProtokollSomDeltaker">
          {{ 'Protokollført møtedeltaker i {antall} fremtidige møter'|translate: {antall: assosiasjoner().antTilknyttetFremtidigIkkelaastProtokollSomDeltaker} }}
        </li>
      }
      @if (assosiasjoner().antTilknyttetFremtidigIkkelaastSakSomAnsvarlig > 0) {
        <li class="e2e-erTilknyttetFremtidigIkkelaastSakSomAnsvarlig">
          {{ 'Saksansvarlig for {antall} saker i fremtidige møter'|translate: {antall: assosiasjoner().antTilknyttetFremtidigIkkelaastSakSomAnsvarlig} }}
        </li>
      }
      @if (assosiasjoner().erTilknyttetMalmoete) {
        <li class="e2e-erTilknyttetMalmoete">
          {{ 'Møtedeltaker og saksansvarlig i møtemalen'|translate }}
        </li>
      }
    </ul>
  }
}
@if (!harAssosiasjoner) {
  <p>{{ 'Vennligst bekreft at du vil stenge tilgangen.'|translate }}</p>
}
<tips>
  {{ 'Du kan når som helst gjenåpne {medlem}s tilgang.'|translate: {medlem: medlem().navn} }}
</tips>
@if (assosiasjoner().antTilknyttetDokumentSomSignatarSomIkkeHarSignert > 0) {
  <inline-melding type="feil" class="e2e-erTilknyttetDokumentSomSignatarSomIkkeHarSignert">
    {{ '{medlem} har {antall} usignert dokumenter. Uten tilgang til gruppen kan hen ikke signere.'|translate: {medlem: medlem().navn, antall: assosiasjoner().antTilknyttetDokumentSomSignatarSomIkkeHarSignert} }}
  </inline-melding>
}
